<dx-validation-group>
  <div class="login-header">
    <img class="profile-user-img img-fluid img-circle" src="../../../../assets/logo.png" alt="{{appInfo.altCaption}}">
    <div class="title">{{appInfo.title}}</div>
    <div class="subtitle">{{appInfo.subtitle}}</div>    
    <div>Sign In to your account</div>
  </div>
  @if(authBase){
  <div class="dx-field">
    <dx-text-box [(value)]="login" placeholder="Login" width="100%">
      <dx-validator>
        <dxi-validation-rule type="required" message="Login is required"></dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
  </div>
  <div class="dx-field">
    <dx-text-box mode="password" [(value)]="password" placeholder="Password" width="100%">
      <dx-validator>
        <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
      </dx-validator>
    </dx-text-box>
  </div>
  }
  @if (!isPasswordScaduta) {
  <div class="dx-field">
    @if(authBase){
    <dx-button type="default" id="button" (click)="onLoginClick()" [height]="40" width="-webkit-fill-available"
      [disabled]="disabledButtonLogin">
      <dx-load-indicator class="button-indicator" [visible]="visibleLoadIndicatorLogin">
      </dx-load-indicator>
      <span class="dx-button-text">Login</span>
    </dx-button>
    }
    @if(hasLogin365 && authAvanzato){
    <dx-button type="default" text="Login con Microsoft 365" (click)="loginWithMicrosoft()" [height]="40"
      width="-webkit-fill-available" class="btn-entra-id"></dx-button>
    }
  </div>
  }
</dx-validation-group>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

@if (isPasswordScaduta) {
<app-popup-password-scaduta [parametriPasswords]="parametriPasswords" [username]="login"
  (popupPasswordScadutaEventEmitter)="onPopupPasswordScadutaEvent($event)">
</app-popup-password-scaduta>
}